import React from "react";
import { FaMedal, FaTrophy } from "react-icons/fa";
import { GiPodium } from "react-icons/gi";

import { DEFAULT_RESULT_IMAGE } from "../utils/resultatsUtils";

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
      <Icon className="text-amber-200" />
      <p className="mt-3 text-2xl font-bold">{value}</p>
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
        {label}
      </p>
    </div>
  );
}

function ResultatsHero({ stats }) {
  return (
    <header className="relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0">
        <img
          src={DEFAULT_RESULT_IMAGE}
          alt="Résultats"
          className="h-full w-full object-cover opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/80 to-amber-950/70" />
      </div>

      <div className="relative mx-auto flex min-h-[360px] w-full max-w-[1280px] flex-col justify-end px-4 pb-20 pt-12 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
            <FaTrophy />
            Vos performances
          </div>

          <h1 className="mt-5 font-titre text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Historique des résultats
          </h1>

          <p className="mt-5 max-w-2xl text-base font-medium leading-8 text-white/75 sm:text-lg">
            Suis tes compétitions, garde la trace de tes combats et construis
            progressivement ton palmarès sportif.
          </p>
        </div>

        <div className="mt-8 grid max-w-3xl gap-3 sm:grid-cols-3">
          <HeroStat icon={FaTrophy} label="Compétitions" value={stats.total} />
          <HeroStat icon={GiPodium} label="Podiums" value={stats.podiums} />
          <HeroStat icon={FaMedal} label="Palmarès" value={stats.inPalmares} />
        </div>
      </div>
    </header>
  );
}

export default ResultatsHero;